<template>
  <form v-on:submit.prevent="save()">
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Nuevo Pedido</h4>
        <p class="category">Complete el pedido</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>N° Factura</label>
              <md-input v-model="Pedido.num_factura" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Nombre</label>
              <md-input v-model="Pedido.nombre" type="text" required></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field maxlength="3">
              <label>Pedido</label>
              <md-textarea v-model="Pedido.descripcion" required></md-textarea>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Telefono</label>
              <md-input
                v-model="Pedido.telefono"
                type="tel"
                required
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Seña</label>
              <md-input
                v-model="Pedido.sena"
                type="number"
                step="0.01"
                min="0.00"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Metodo de pago</label>
              <md-select v-model="Pedido.metodo" name="metodo" id="metodo">
                <md-option value="efectivo">Efectivo</md-option>
                <md-option value="tarjeta">Tarjeta</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Total a pagar</label>
              <md-input
                v-model="Pedido.precio_total"
                type="number"
                step="0.01"
                min="0.00"
                required
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-datepicker v-model="Pedido.fecha">
              <label>Dia</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label></label>
              <md-input v-model="Pedido.hora" type="time"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button type="submit" class="md-raised md-success"
              >Agregar</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import axios from "axios";
import Global from "../../Global";
import Pedido from "../../models/pedido";
export default {
  name: "edit-profile-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      url: Global.url,
      Pedido: new Pedido(null, null, null, null, null, null, null, null, null)
    };
  },
  mounted() {},
  methods: {
    save() {
      this.Pedido.fecha = this.$moment(this.Pedido.fecha).format("Y-MM-DD");
      axios
        .post(this.url + "pedido", this.Pedido, {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(Response => {
          if (Response.status == 200) {
            this.$router.push("Pedidos");
          }
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>
<style></style>
